import {reactLocalStorage} from 'reactjs-localstorage'

export const checkEmployeeTeamType = () => reactLocalStorage.get('loggedEmployeeTeamType') !==
    'S';